import React from 'react';
import SectionTabs from '../SectionTabs';
import InspiringDancersSection from './InspiringDancersSection';

// Award pages, in tab order — add new ones here (and a render line below)
// as they're built (planned: Award Categories, Scoring, Results). Also
// drives the breadcrumb label and the sidebar search (see AdminDashboard.js).
// With one page the tab bar is hidden.
export const AWARDS_SUBSECTIONS = [
  { id: 'inspiring-dancer', label: 'Most Inspiring Dancer', description: "Each school's nomination, with printouts (one per page) for the banquet" },
];

// activeSection is the shared sub-page state (AdminDashboard's regSection).
export default function AwardsSection({ activeSection, setActiveSection }) {
  return (
    <SectionTabs sectionKey="awards" tabs={AWARDS_SUBSECTIONS} activeSection={activeSection} setActiveSection={setActiveSection}>
      {(id) => id === 'inspiring-dancer' && <InspiringDancersSection />}
    </SectionTabs>
  );
}
